module.exports = __webpack_public_path__ + "img/Desert.a1967941.webp";